// extracted by mini-css-extract-plugin
export default {"messageContent":"SignedCommitHeader-module__messageContent--IBgp2"};